import { IOwnedViolation } from '../model/base/annotation';

export enum SaveStatus {
    Succeeded,
    Failed,
    NothingToSave,
    PermissionDeniedToPushToBranch,
    PermissionDeniedToCreateBranch,
    FileSizeLimitExceeded,
    BranchLocked,
    GitHubPermissionDeniedOrResourceNotExist
}

export interface ISaveResult {
    status: SaveStatus;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any;
    violations?: IOwnedViolation[];
}
